<div class="group relative" [class.!hidden]="!!item">
  <input
    #inputEl
    tsqTextInput
    [schema]="schema"
    class="control font-base"
    autocomplete="off"
    [icon]="hasSearchIcon ? icons.magnifyingGlass : undefined"
    [(ngModel)]="input"
    [placeholder]="placeholder | translate"
    [disabled]="disabled"
    [typeahead]="dataSource$"
    [typeaheadAsync]="true"
    [typeaheadWaitMs]="1000"
    [typeaheadMinLength]="minLength"
    [typeaheadOptionsInScrollableView]="numberOfOptions"
    [typeaheadScrollable]="true"
    [typeaheadLatinize]="true"
    [typeaheadOptionField]="'text'"
    [typeaheadItemTemplate]="itemTemplate"
    [container]="container"
    (typeaheadLoading)="loading = $event; adjustDropdownWidth()"
    (typeaheadOnSelect)="onSelect($event)"
    (typeaheadOnBlur)="onTypeaheadBlur()"
    (typeaheadOnPreview)="adjustDropdownWidth()"
    (blur)="onInputBlur()"
  />

  <div
    class="absolute top-full z-10 mt-4 flex w-full justify-center rounded bg-white p-16 shadow"
    *ngIf="loading"
  >
    <tsq-small-loader />
  </div>
</div>

<div
  class="tsq-card flex items-center justify-between px-16 py-8"
  [class.border-1]="error"
  [class.border-red]="error"
  *ngIf="!!item"
>
  <ng-container *ngTemplateOutlet="selectedTemplate; context: selectedContext"></ng-container>
  <button
    [disabled]="disabled"
    [class.text-red]="!disabled"
    [class.text-coal-tertiary]="disabled"
    (click)="onSelect(null)"
  >
    <tsq-icon [icon]="icons.trash" />
  </button>
</div>

<div class="text-red label-text mt-4 uppercase" *ngIf="error">{{ finalErrorMessage }}</div>
